<div class="globalContainer">
    <div id="cart">
        <h1>Paiement</h1>
        <h5 style="display: flex; align-items: flex-end">
            <mat-icon class="secureIcon">https</mat-icon>
            Sécurisé par
            <mat-icon svgIcon="stripe" class="StripeIcon"></mat-icon>
        </h5>
        <mat-spinner [diameter]="20" *ngIf="isAskingPayment"></mat-spinner>
        <div *ngIf="!paymentInfo && !isAskingPayment">
            <button class="reloadPaymentBtn" mat-raised-button color="primary" (click)="askPayment()">
                <mat-icon>refresh</mat-icon>
                Relancer le paiement
            </button>
        </div>

        <div [formGroup]="paymentElementForm">
            @if (paymentInfo) {
                <article class="infoItem">
                    <p class="itemTitle">
                        Prix total TTC :
                        <span> {{ paymentInfo.amount / 100 | currency: 'EUR' : 'symbol' : undefined : 'fr' }}</span>
                    </p>
                </article>
            }
            <!-- Formulaire d'infos de paimement - pas utile -->
            <!-- Nom -->
            <div style="display: none">
                <mat-form-field class="example-full-width" appearance="fill">
                    <input matInput placeholder="name" formControlName="name" />
                </mat-form-field>
                <!-- Mail -->
                <mat-form-field class="example-full-width" appearance="fill">
                    <input matInput placeholder="Email" type="email" formControlName="email" />
                </mat-form-field>
                <!-- Addresse -->
                <mat-form-field class="example-full-width" appearance="fill">
                    <input matInput placeholder="Address" formControlName="address" />
                </mat-form-field>
                <!-- Code postal -->
                <mat-form-field class="example-full-width" appearance="fill">
                    <input matInput placeholder="ZIP Code" formControlName="zipcode" />
                </mat-form-field>
                <!-- Nom de la ville -->
                <mat-form-field class="example-full-width" appearance="fill">
                    <input matInput placeholder="city" formControlName="city" />
                </mat-form-field>
            </div>
            @if (elementsOptions.clientSecret) {
                <br />
                <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                    <ngx-stripe-payment [options]="paymentElementOptions" />
                </ngx-stripe-elements>
            }
            <div class="actionsContainer">
                <button tabindex="-1" (click)="goToCart()" mat-stroked-button color="secondary">Retour</button>
                <button
                    id="payBtn"
                    *ngIf="paymentInfo"
                    mat-raised-button
                    color="primary"
                    (click)="pay()"
                    [disabled]="paying()"
                >
                    <mat-icon> credit_card </mat-icon>
                    Paiement
                </button>
            </div>
            <div class="loadingCart" *ngIf="paying()">
                <mat-spinner [diameter]="50"></mat-spinner>
                <i>Vérification du paiement ...</i>
            </div>
        </div>
    </div>
</div>
